import { render, staticRenderFns } from "./ProductDetailTabs.vue?vue&type=template&id=a15dc4aa&scoped=true&"
import script from "./ProductDetailTabs.vue?vue&type=script&lang=js&"
export * from "./ProductDetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailTabs.vue?vue&type=style&index=0&id=a15dc4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15dc4aa",
  null
  
)

export default component.exports